// Footer.jsx
import React from "react";
import "../Styles/Footer.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../Image/logo.png";

const Footer = () => {
  const { t } = useTranslation();

  const openToTop = () => {
    document.getElementById("top")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <img src={Logo} width={200} height={60} alt="logo in footer"/>
          <p>{t("footer_about_text")}</p>
        </div>

        <div className="footer-links">
          <h3>{t("footer_quick_links")}</h3>
          <ul>
            <li>
              <Link to="/" onClick={openToTop}>
                {t("nav_home")}
              </Link>
            </li>
            <li>
              <Link to="/services" onClick={openToTop}>
                {t("nav_services")}
              </Link>
            </li>
            <li>
              <Link to="/projects" onClick={openToTop}>
                {t("nav_projects")}
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={openToTop}>
                {t("nav_about")}
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={openToTop}>
                {t("nav_contact")}
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>{t("footer_contact")}</h3>
          <p>📍 {t("contact_address")}</p>
          <p>📞 {t("contact_phone")}</p>
          <p>✉️ {t("contact_email")}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Emibau. {t("footer_rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
